import React from "react";
import "./SkeletonLoader.css"; // Import CSS for shimmer effect

const SkeletonLoader = () => {
    return (
        <div className="skeleton-container">
            <div className="skeleton skeleton-navbar"></div>
            <div className="skeleton skeleton-box"></div>
            <div className="skeleton skeleton-text"></div>
            <div className="skeleton skeleton-text short"></div>
        </div>
    );
};

export default SkeletonLoader;
